export const ORDER_SET = 'at/taskManagement/tasksTable/configurationMenu/ORDER_SET'
export const SELECTED_SET = 'at/taskManagement/tasksTable/configurationMenu/SELECTED_SET'



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/configurationMenu/actionTypes.js